import { Component, OnInit } from '@angular/core';
import { User, AuthenticationService } from '@csx/security';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  online: boolean;

  constructor(private _router: Router, private localStorage: LocalStorageService, private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    window.addEventListener('online', this.onNetworkStatusChange.bind(this));
    window.addEventListener('offline', this.onNetworkStatusChange.bind(this));

    if (window.navigator.onLine) {
      this.online = true;
    }
    else {
      this.online = false;
    }

    if (window.navigator.onLine && this.authService.isAuthenticated) {
      this.router.navigate(['authorities']);
    }
  }

  onNetworkStatusChange() {
    if (window.navigator.onLine) {
      this.online = true;
    } else {
      this.online = false;
    }
  }

  login() {
    if (window.navigator.onLine && (!this.authService.isAuthenticated)) {
      this.authService.login();
    } else {
      this.router.navigate(['authorities']);
    }


  }
}
